export const WORKSTREAM_BANNER_VISIBLE_STORAGE_KEY = 'workstream-banner-visible'
